/**
 * Creates an AbortController that aborts when `externalSignal` aborts.
 * Use for cancellable fetch streams that also need local cleanup.
 */
export function createLinkedAbortController(
  externalSignal?: AbortSignal,
): AbortController {
  const controller = new AbortController();

  if (!externalSignal) {
    return controller;
  }

  if (externalSignal.aborted) {
    controller.abort(externalSignal.reason);
    return controller;
  }

  externalSignal.addEventListener(
    "abort",
    () => controller.abort(externalSignal.reason),
    { once: true },
  );

  return controller;
}

export type StreamRequestOptions = {
  signal?: AbortSignal;
};
